import api from './api';

export interface RentalProduct {
  id: string;
  title: string;
  handle: string;
  imageUrl: string | null;
  retailWeeklyRateCents: number | null;
  bilateralPriceCents: number | null;
  minRentalWeeks: number | null;
  variants: Array<{ id: string; title: string; sku: string; price: string }>;
}

export interface WrapProduct {
  id: string;
  title: string;
  imageUrl: string | null;
  variants: Array<{ id: string; title: string; sku: string; price: string }>;
}

export interface AddOnProduct {
  id: string;
  title: string;
  imageUrl: string | null;
  vendor?: string | null;
  options?: Array<{ name: string; values: string[] }>;
  variants: Array<{
    id: string;
    title: string;
    sku: string;
    price: string;
    selectedOptions?: Array<{ name: string; value: string }>;
  }>;
}

export interface CreateDirectOrderInput {
  productId: string;
  variantId: string;
  rentalWeeks: number;
  surgeryDate: string;
  isBilateral?: boolean;
  wrapProductId: string;
  wrapVariantId: string;
  addOns: Array<{ productId: string; variantId: string }>;
  patientFirstName: string;
  patientLastName: string;
  patientPhone: string;
  referringDoctor?: string;
}

export interface CreateDirectOrderResult {
  status: 'pending_payment';
  draftOrderId: string;
  shopifyOrderName?: string;
  invoiceUrl?: string;
}

const BASE = '/rent';

export const directRentalApi = {
  getProducts: async (): Promise<RentalProduct[]> => {
    const r = await api.get<RentalProduct[]>(`${BASE}/products`);
    return r.data;
  },
  getProductByHandle: async (handle: string): Promise<RentalProduct> => {
    const r = await api.get<RentalProduct>(`${BASE}/products/${handle}`);
    return r.data;
  },
  getWraps: async (): Promise<WrapProduct[]> => {
    const r = await api.get<WrapProduct[]>(`${BASE}/wraps`);
    return r.data;
  },
  getAddons: async (): Promise<AddOnProduct[]> => {
    const r = await api.get<AddOnProduct[]>(`${BASE}/addons`);
    return r.data;
  },
  createOrder: async (input: CreateDirectOrderInput): Promise<CreateDirectOrderResult> => {
    const r = await api.post<CreateDirectOrderResult>(`${BASE}/orders`, input);
    return r.data;
  },
};

export default directRentalApi;
